import React, { Component } from "react";
import { connect } from "react-redux";

import {
  ModalContainer,
  KeyboardView,
  Title,
  Card,
  ContentfulRichText,
  Bold,
  Copy,
  Row,
  Video,
  Wrapper,
  Button
} from "app/NativeComponents/common";
import { Header } from "app/NativeComponents/snippets";
import {
  appRedirect,
  toggleCancelPage,
  setCancelPage,
  pauseOrCancelPlan,
  loadCancelCenter,
  updatePlan,
  checkIfUserHasModule
} from "app/NativeActions";
import Offer from "./Offer";
import SecondVideoPage from "./SecondVideoPage";
import PausedPlanPage from "./PausedPlanPage";
import FinalCancelPage from "./FinalCancelPage";
class CancelPageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cancel_center_content: null,
      cancel_center_loading: true,
      show_offer: false,
      offer: null,
      selected_reason: null,
      first_cancel_reason: null,
      second_cancel_reason: null,
      no_paused: false
    };

    this.handleBack = this.handleBack.bind(this);
    this.toggleOffer = this.toggleOffer.bind(this);
    this.setFirstCancelReason = this.setFirstCancelReason.bind(this);
    this.setSecondCancelReason = this.setSecondCancelReason.bind(this);
    this.optOutOfPaused = this.optOutOfPaused.bind(this);
  }

  componentDidMount() {
    if (this.props.cancel_page) {
      this.loadData(this.props.cancel_page.engine_slug);
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.cancel_page &&
      this.props.cancel_page !== prevProps.cancel_page
    ) {
      this.loadData(this.props.cancel_page.engine_slug);
    }
  }
  loadData(slug) {
    this.setState({
      cancel_center_content: null,
      cancel_center_loading: true
    });
    loadCancelCenter(slug)
      .then(data => {
        if (data && data.items && data.items.length > 0) {
          let show_offer = false;
          let offer = null;
          if (
            data.items[0].fields.offers &&
            data.items[0].fields.offers.length > 0
          ) {
            show_offer = true;
            offer =
              data.items[0].fields.offers[
                Math.floor(Math.random() * data.items[0].fields.offers.length)
              ];
          }
          console.log(offer);
          this.setState({
            cancel_center_content: data.items[0]
              ? data.items[0].fields
                ? data.items[0].fields
                : null
              : null,
            cancel_center_loading: false,
            show_offer,
            offer
          });
        }
        this.setState(() => ({ cancel_center_loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ cancel_center_loading: false }));
      });
  }

  toggleOffer(show_offer) {
    this.setState({
      show_offer
    });
  }

  setFirstCancelReason(option) {
    this.setState({
      selected_reason: option,
      first_cancel_reason: option ? option.fields.optionTitle : null
    });
  }
  setSecondCancelReason(second_cancel_reason) {
    this.setState({
      second_cancel_reason
    });
  }
  optOutOfPaused(no_paused) {
    this.setState({
      no_paused
    });
  }

  handleBack() {
    this.setState({
      cancel_center_content: null,
      cancel_center_loading: false,
      show_offer: false,
      offer: null,
      selected_reason: null,
      first_cancel_reason: null,
      second_cancel_reason: null,
      no_paused: false
    });
    this.props.setCancelPage({
      engine_slug: null
    });
    this.props.toggleCancelPage(false);
  }

  checkIfThisIsTheLastPlan() {
    const { cancel_page, plan_modules, user } = this.props;

    const driving_info = checkIfUserHasModule({
      plan_modules,
      user,
      slug: "driving"
    });
    const lists_info = checkIfUserHasModule({
      plan_modules,
      user,
      slug: "lists"
    });

    const messages_info = checkIfUserHasModule({
      plan_modules,
      user,
      slug: "messages"
    });

    if (driving_info.has_module && cancel_page.engine_slug != "driving") {
      return false;
    } else if (lists_info.has_module && cancel_page.engine_slug != "lists") {
      return false;
    } else if (
      messages_info.has_module &&
      cancel_page.engine_slug != "messages"
    ) {
      return false;
    }

    return true;
  }

  render() {
    const {
      show_cancel_page,
      cancel_page,
      device,
      isMobile,
      colors,
      plan_modules,
      user
    } = this.props;
    const {
      cancel_center_content,
      cancel_steps,
      show_offer,
      selected_reason,
      first_cancel_reason,
      second_cancel_reason,
      no_paused,
      offer
    } = this.state;

    if (show_cancel_page && cancel_page && cancel_center_content) {
      const next_billing_date = checkIfUserHasModule({
        plan_modules,
        user,
        slug: cancel_page.engine_slug
      }).module_info?.next_billing_date;
      return (
        <ModalContainer>
          {show_offer && offer ? (
            <Offer
              offer={offer}
              device={device}
              token={this.props.token}
              handleBack={this.handleBack}
              toggleOffer={this.toggleOffer}
              pauseOrCancelPlan={this.props.pauseOrCancelPlan}
              cancel_page={cancel_page}
            />
          ) : second_cancel_reason &&
            cancel_center_content.showPauseOption &&
            !no_paused &&
            this.checkIfThisIsTheLastPlan() ? (
            <PausedPlanPage
              token={this.props.token}
              device={device}
              cancel_page={cancel_page}
              cancel_center_content={cancel_center_content}
              setSecondCancelReason={this.setSecondCancelReason}
              handleBack={this.handleBack}
              optOutOfPaused={this.optOutOfPaused}
              updatePlan={this.props.updatePlan}
              appRedirect={this.props.appRedirect}
            />
          ) : second_cancel_reason ? (
            <FinalCancelPage
              token={this.props.token}
              device={device}
              cancel_page={cancel_page}
              cancel_center_content={cancel_center_content}
              setSecondCancelReason={this.setSecondCancelReason}
              handleBack={this.handleBack}
              is_last_plan={this.checkIfThisIsTheLastPlan()}
              optOutOfPaused={this.optOutOfPaused}
              second_cancel_reason={second_cancel_reason}
              first_cancel_reason={first_cancel_reason}
              updatePlan={this.props.updatePlan}
              next_billing_date={next_billing_date}
              appRedirect={this.props.appRedirect}
            />
          ) : selected_reason ? (
            <SecondVideoPage
              token={this.props.token}
              device={device}
              colors={colors}
              cancel_page={cancel_page}
              selected_reason={selected_reason}
              setFirstCancelReason={this.setFirstCancelReason}
              setSecondCancelReason={this.setSecondCancelReason}
              pauseOrCancelPlan={this.props.pauseOrCancelPlan}
              handleBack={this.handleBack}
              offer={offer}
            />
          ) : (
            <Wrapper style={{ flex: 1 }}>
              <Header
                title={cancel_page.title}
                leftButtonIcon={"arrow-back"}
                leftButtonAction={() => {
                  this.handleBack();
                }}
              />
              <KeyboardView
                style={{
                  flex: 1,
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <Wrapper
                  style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center",
                    margin: device == "desktop" ? "0px auto" : 0
                  }}
                >
                  <Wrapper
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      maxWidth: 650,
                      padding: 20
                    }}
                  >
                    {cancel_center_content.video ? (
                      <Card
                        style={{
                          height: device == "desktop" ? 270 : 180,
                          width: device == "desktop" ? 480 : 320,
                          margin: device == "desktop" ? "0px auto" : 0,
                          overflow: "hidden"
                        }}
                      >
                        <Video
                          video={cancel_center_content.video.fields.file.url}
                          height={device == "desktop" ? 270 : 180}
                          width={device == "desktop" ? 480 : 320}
                          autoPlay={true}
                          controls={true}
                        />
                      </Card>
                    ) : null}
                    <Wrapper style={{ paddingTop: 20, paddingBottom: 20 }}>
                      <Title style={{ textAlign: "center", marginBottom: 10 }}>
                        {cancel_center_content.title}
                      </Title>
                      <ContentfulRichText
                        style={{ textAlign: "center" }}
                        richText={cancel_center_content.description}
                      />
                    </Wrapper>
                  </Wrapper>
                  <Wrapper
                    style={{
                      flex: 1,
                      alignItems: "center",
                      justifyContent: "center"
                    }}
                  >
                    <Copy style={{ textAlign: "center" }}>
                      {cancel_center_content.cancelOptionsTitle}
                    </Copy>
                    <Wrapper style={{ padding: 20, paddingBottom: 40 }}>
                      {cancel_center_content.cancelOptions &&
                        cancel_center_content.cancelOptions.map((option, i) => {
                          return (
                            <Button
                              key={"option_" + i}
                              onPress={() => {
                                this.setFirstCancelReason(option);
                              }}
                            >
                              <Card
                                style={{
                                  padding: 15,
                                  paddingRight: 30,
                                  paddingLeft: 30,
                                  borderRadius: 30,
                                  alignItems: "center",
                                  justifyContent: "center"
                                }}
                              >
                                <Copy style={{ textAlign: "center" }}>
                                  <Bold>{option.fields.optionTitle}</Bold>
                                </Copy>
                              </Card>
                            </Button>
                          );
                        })}
                    </Wrapper>
                  </Wrapper>
                </Wrapper>
              </KeyboardView>
            </Wrapper>
          )}
        </ModalContainer>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ auth, native, billing, settings, marketing }) => {
  const { token, user } = auth;
  const { device, isMobile, platform } = native;
  const { colors } = settings;
  const { cancel_page, show_cancel_page, plan_modules } = billing;
  return {
    token,
    user,
    device,
    platform,
    isMobile,
    colors,
    cancel_page,
    show_cancel_page,
    plan_modules
  };
};

export default connect(mapStateToProps, {
  appRedirect,
  toggleCancelPage,
  setCancelPage,
  updatePlan,
  pauseOrCancelPlan
})(CancelPageModal);
